import { DatePicker } from "@/shared/components";
import { cn } from "@/shared/utils";
import { ComponentProps, PropsWithChildren } from "react";
import { OnSelectHandler } from "@daypicker/react";
import { Input } from "./input";

type TimeInputProps = ComponentProps<"input"> & {
    readOnly?: boolean | undefined;
};

export function TimeInput({ readOnly, ...props }: TimeInputProps) {
    if (readOnly) {
        return <span className="text-content-placeholder w-full px-3 py-2">{props.value || "Onbekend"}</span>;
    }

    return (
        <Input
            type="time"
            className={cn(
                "w-full appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
            )}
            {...props}
        />
    );
}

type DateInputProps = Omit<ComponentProps<"input">, "onSelect"> & {
    readOnly?: boolean | undefined;
    date: Date | undefined;
    onSelect: OnSelectHandler<Date>;
};

export function DateInput({ readOnly, date, onSelect, ...props }: DateInputProps) {
    if (readOnly) {
        return <span className="text-content-placeholder w-full px-3 py-2">{props.value || "Onbekend"}</span>;
    }

    return <DatePicker date={date} onSelect={onSelect} />;
}

/**
 * Generic wrapper to generalize styling for DateTimeInput
 *
 * We might want to extend this to pass it a single Date value and passes the relevant values down to TimeInput and DateInput
 *
 * @constructor
 */
export function DateTimeInput({ children, className }: PropsWithChildren<ComponentProps<"div">>) {
    return <div className={cn("grid grid-cols-[auto_auto] justify-start gap-x-4", className)}>{children}</div>;
}
